export default "__VITE_ASSET__C5ux_7Wl__"